export const APP_NAME = 'Classino';
export const APP_DESCRIPTION = 'Classino Web Site';

export const VUE_VERSION = "3.3.4";